export const TextStyle = {
  fontFamily: "body",
  fontSize: "11px",
  fontWeight: "600",
  letterSpacing: ".76px",
  lineHeight: "44px",
  mr: 1,
  textTransform: "uppercase",
};

export const BoxStyle = {
  mr: 1,
  minWidth: "170px",
};

export const SimpleBoxStyle = {
  minWidth: "170px",
};
